'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSimple = isSimple;
exports.memoize = memoize;
exports.hoistRef = hoistRef;
exports.undeclaredRef = undeclaredRef;
exports.getShadowingIdentifiers = getShadowingIdentifiers;
exports.containsReferencedIdentifier = containsReferencedIdentifier;
exports.insertDeclarationBefore = insertDeclarationBefore;
exports.checkFalsePositiveReference = checkFalsePositiveReference;
exports.spreadIsAlreadySafe = spreadIsAlreadySafe;
exports.restToSpread = restToSpread;

var _types = require('../types');

var _types2 = _interopRequireDefault(_types);

var _getLoc = require('ast-loc-utils/lib/getLoc');

var _getLoc2 = _interopRequireDefault(_getLoc);

var _placeAtLoc = require('ast-loc-utils/lib/placeAtLoc');

var _placeAtLoc2 = _interopRequireDefault(_placeAtLoc);

var _placeAtNode = require('ast-loc-utils/lib/placeAtNode');

var _placeAtNode2 = _interopRequireDefault(_placeAtNode);

var _span = require('ast-loc-utils/lib/span');

var _span2 = _interopRequireDefault(_span);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isSimple(refTarget) {
  return (0, _types.isa)(refTarget, "Identifier") || (0, _types.isa)(refTarget, "Super") || (0, _types.isa)(refTarget, "ThisExpression");
} // Memoize an expression with a variable to avoid duplication of side effects.
function memoize(path, target) {
  var varName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "ref";
  var isDeclared = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  if (isSimple(target)) {
    return { ref: target, assign: target, declarator: null, isComplex: false };
  } else {
    var loc = (0, _span2.default)((0, _getLoc2.default)(target), 1);

    var ref = isDeclared ? (0, _placeAtLoc2.default)(path.scope.generateDeclaredUidIdentifier(varName), loc) : (0, _placeAtLoc2.default)(path.scope.generateUidIdentifier(varName), loc);

    return {
      ref,
      isComplex: true,
      assign: (0, _placeAtLoc2.default)(_types2.default.assignmentExpression("=", ref, target), loc),
      declarator: (0, _placeAtLoc2.default)(_types2.default.variableDeclarator(ref, target), loc)
    };
  }
} // Hoist a ref up to the enclosing scope if needed.
function hoistRef(path, refTarget) {
  var varName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "ref";

  return memoize(path, refTarget, varName, true);
} // Create a variable declarator for a ref in the enclosing scope, if
// needed
function undeclaredRef(path, refTarget) {
  var varName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "ref";

  return memoize(path, refTarget, varName, false);
} // Get all identifiers in the given `VariableDeclaration` that would shadow
// identifiers defined in a higher scope.
function getShadowingIdentifiers(declarationPath) {
  if (!declarationPath.scope.parent) return [];

  return function () {
    var _arr = [];for (var _arr4 = declarationPath.node.declarations, _i3 = 0, _len4 = _arr4.length; _i3 < _len4; _i3++) {
      for (var _obj2 = declarationPath.get(`declarations.${_i3}`).getBindingIdentifiers(), _i4 = 0, _keys2 = Object.keys(_obj2), _len5 = _keys2.length; _i4 < _len5; _i4++) {
        var _k2 = _keys2[_i4];var _id = _obj2[_k2];
        if (declarationPath.scope.parent.hasBinding(_id.name)) _arr.push(_id);
      }
    }return _arr;
  }();
}

// Check if a path contains a reference to an identifier
function containsReferencedIdentifier(path, identifier) {
  var result = false;
  var identifierName = identifier.name;


  path.traverse({
    ReferencedIdentifier(refPath) {
      if (checkFalsePositiveReference(refPath)) {
        refPath.skip();
      } else if (refPath.node.name === identifierName) {
        result = true;
        refPath.stop();
      }
    } });

  return result;
} // Insert a prior declaration and register it as a binding with Babel
function insertDeclarationBefore(path, id, init, kind, loc) {
  path.insertBefore((0, _placeAtLoc2.default)(_types2.default.variableDeclaration(kind, [(0, _placeAtLoc2.default)(_types2.default.variableDeclarator(id, init), loc)]), loc));
  return path.scope.registerBinding(kind, path.getSibling(path.key - 1));
} // Workaround a babel bug with Flow types
// XXX: there are probably uncovered cases here. test again with babel 7 later
function checkFalsePositiveReference(refPath) {
  var node = refPath.node;

  var parentNode = refPath.parentPath.node;
  if (!parentNode) return false;

  if (parentNode.type === "ObjectTypeProperty" && parentNode.key === node) {
    return !parentNode.computed;
  } else if (parentNode.type === "FunctionTypeParam") {
    return true;
  } else if (parentNode.type === "ExportSpecifier") {
    // In `export { x } from 'y'`, x is not actually referenced.
    var parent2 = refPath.parentPath.parentPath.node;
    if (parent2.type === "ExportNamedDeclaration" && parent2.source) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
} // Prevent a spread from being transformed by the safe-spread transform
function spreadIsAlreadySafe(spread) {
  spread._safe = true;
  return spread;
} // Convert function args from rest to spread
function restToSpread(argList) {
  return function () {
    var _arr3 = [];for (var _i5 = 0, _len6 = argList.length; _i5 < _len6; _i5++) {
      var _arg = argList[_i5];
      if ((0, _types.isa)(_arg, "RestElement")) {
        _arr3.push(spreadIsAlreadySafe((0, _placeAtNode2.default)(_types2.default.spreadElement(_arg.argument), _arg)));
      } else {
        _arr3.push(_arg);
      }
    }return _arr3;
  }();
}